import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoginComponent } from 'src/app/auth/login/login.component';
declare var $: any;

import SwiperCore,{Navigation,Pagination,Scrollbar,A11y,Virtual,Zoom,Autoplay,Thumbs,Controller,Swiper} from 'swiper';
import { interval } from 'rxjs';
SwiperCore.use([Navigation,Pagination,Scrollbar,A11y,Virtual,Zoom,Autoplay,Thumbs,Controller]);


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseClass<any> implements OnInit {

  modalRef?: BsModalRef;
  
  public data: any;
  //public casinoData: any;
  public homeData: any;
  public inPlayData: any;
  public listRes: any;
  public marketsReq: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public oddsLisDisNew: any = {};
  public exposLisDis: any = {};
  public newOddsEnable: boolean = false;
  public marketData: any;

  public menuItems: any[] = [];
  public hRaceList: any[] = [];
  public gRaceList: any[] = [];


  constructor(
    public service: WebserviceService,
    public _common: CommonService,
    public router: Router,
    public _shared: SharedService,
    @Inject(DOCUMENT) public document: Document,
    private modalService: BsModalService
  ) 
  { 
    super();
    this.constructorCallData() 
  }

  constructorCallData() {
    //emit value in sequence every given second\
    const sub2 = interval(this.env.pollers.listOddsData).subscribe(val => {
      if (this.webSocketUrl != '') {
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.marketData);
        } else {
          this.getOdds(this.marketsReq);
        }
      }
    });
    this.subs.push(sub2);
  }

  ngOnInit(): void {
    $(function () {
      var body = $('body');
      body.addClass('login-background');
      body.addClass('home');
      body.removeClass('loading');
    });

    this.loadJsFile("assets/js/app.js"); 

    this.getData();
    this.menuItems = this.menu;

    var swiper1 = new Swiper(".main-slider", {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
          1080: {
            slidesPerView: 9,
            spaceBetween: 10,
          }
        },
    });

    var swiper2 = new Swiper(".marketslider", {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: false,
      autoplay: {
        delay: 5500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
          1080: {
            slidesPerView: 3,
            spaceBetween: 10,
          }
        },
    });
  }
  

  getServices(): IbaseService<any> {
    return this.service;
  }


  public loadJsFile(url:any) {  
    let node = document.createElement('script');  
    node.src = url;  
    node.type = 'text/javascript';  
    document.getElementsByTagName('head')[0].appendChild(node);  
  }
  

  getData() {
    this.isLoad = true;
    this.data = undefined;
    this.homeData = undefined;
    let url = this.api.eventListNewG;

    this.getServices().Get(`${this.env.baseUrl + url}`).subscribe(
      (res: any) => {
        if (res.status == true) {
          // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
          this.listRes = res.data;
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
          this.setRaceSideMenu(7, res.data.races);
          this.setRaceSideMenu(4339, res.data.races);
          res.data.races.forEach((element: any) => {
            element['in_play'] = 1;
          });
          let events = [...res.data.events, ...res.data.races];

          this.hRaceList = this.findUpComingRace(res.data.races, 7);
          this.gRaceList = this.findUpComingRace(res.data.races, 4339);

          this.commonLogics(res, events);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  commonLogics(res: any, events: any) {
    this.webSocketUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
    // this.setLocalItem('wsu', this.webSocketUrl);
    this.setLocalItem('ws', this.webSocketUrl, false);
    events = this.UTC_to_Local_timeZone(events);
    this.marketsReq = this.genMarketReq(events);

    this.marketData = res?.data;
    this.data = events;
    this.homeData = this.getHomeData(events);
    
    this.isLoad = false;
    if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
      this.newOddsEnable = true;
      this.getOddsNew(this.marketsReq, res?.data);
    } else {
      this.newOddsEnable = false;
      this.getOdds(this.marketsReq);
    }
  }

  getOdds(req: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.odds}`, req).subscribe(
      (res) => {
        res = this.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getOddsNew(req: any, resData: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this.pipe_string_to_JSON(res);
        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);

        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.oddsLisDis = this.oddsLisDisNew;

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getHomeData(data: any) {
    const groupedInPlay = this.groupBy(data, (dat: any) => dat.in_play);
    const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);

    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]
    
    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    return uniqueArray;
  }

  setRaceSideMenu(id: any, items: any) {
    let dt = items.filter((s: any) => { return Number(s.event_type_id) == Number(id) });
    this.setLocalItem(`sideRaceMenu${id}`, dt);
    this._shared.emitSideMenu(dt);
  }

  // getData() {
  //   this.isLoad = true;
  //   let api = this.isLogin() ? this.api.eventListNew : this.api.eventListNewG;
  //   this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
  //     (res: ResFormat) => {
  //       if (res.status == true) {
  //         // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
  //         this.setLocalItem('sideMenu', res.data.events);
  //         this._shared.emitSideMenu(res.data.events);
  //       } else {
  //         this._common.checkForForceChangePassword(res);
  //       }
  //     },
  //     (err) => {
  //       console.log(err);
  //     });
  // }

  openLogin(e: any) {
    this._common.openModalWithComponent({ isDemoLoginComp: false }, LoginComponent, 'modal-dialog-centered login-popup')
  }

  confirmSport(event_id:any){
    this.router.navigate([`/sports`, event_id]);
  }

  confirmCasino(event_id:any){
    this.router.navigate([`/casino`, event_id]);
  }

  redirectICasinoLobby(mn_id: any){
    this.router.navigate(['/casino', mn_id])
  }

  confirmCasinoDetail(mn_id:any, game_id:any){
    if(this.isLogin()){
      this.router.navigate(['/casino-detail', mn_id, game_id]);
    }else{
      this.openLogin('');
    }
  }

  openModal(template: TemplateRef<any>) {
    
    let cls = 'rulesModaldetail';
    let id = 'modal-md';

    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: cls }, { id: id })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
    
    $(function () {
      var body = $('body');
      body.removeClass('home');
    });
  }

}
